// assets/chatbot-widget.js
(function () {
  const CHATBOT_API_URL = "https://elbdampf-dashboard.clueless.com.de/api/chatbot/message";
  const STORAGE_KEY = "elbdampf_chatbot_history";

  function getCustomerEmail() {
    try {
      return (window.ELBDAMPF_CUSTOMER && window.ELBDAMPF_CUSTOMER.email) || "";
    } catch (e) {
      return "";
    }
  }

  const CHAT_ICON =
    '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M4 4h16v12H7l-3 3V4z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>' +
    "</svg>";
  const SEND_ICON =
    '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M4 12l16-8-6 8 6 8-16-8z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>' +
    "</svg>";

  function loadHistory() {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "[]");
    } catch (e) {
      return [];
    }
  }

  function saveHistory(history) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(history));
    } catch (e) {
      // sessionStorage unavailable (private mode etc.) - fail silently, history just won't persist
    }
  }

  function stripMarkdown(text) {
    return text
      .replace(/\*\*(.+?)\*\*/g, "$1")
      .replace(/\*(.+?)\*/g, "$1")
      .replace(/`(.+?)`/g, "$1")
      .replace(/^#{1,6}\s+/gm, "");
  }

  const URL_RE = /(https?:\/\/[^\s]+|(?:^|\s)\/pages\/[^\s]+)/g;

  function renderRichText(bubble, text) {
    let lastIndex = 0;
    let match;
    URL_RE.lastIndex = 0;
    while ((match = URL_RE.exec(text)) !== null) {
      const raw = match[0];
      const leadingSpace = raw.startsWith(" ") ? " " : "";
      const url = raw.trim();
      if (match.index > lastIndex) {
        bubble.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
      }
      if (leadingSpace) bubble.appendChild(document.createTextNode(leadingSpace));
      const a = document.createElement("a");
      a.href = url;
      a.target = "_blank";
      a.rel = "noopener noreferrer";
      a.textContent = url;
      bubble.appendChild(a);
      lastIndex = match.index + raw.length;
    }
    if (lastIndex < text.length) {
      bubble.appendChild(document.createTextNode(text.slice(lastIndex)));
    }
  }

  function renderMessage(container, role, text) {
    const row = document.createElement("div");
    row.className = "chatbot-msg-row " + (role === "user" ? "user" : "bot");
    const bubble = document.createElement("div");
    bubble.className = "chatbot-msg-bubble";
    if (role === "user") {
      bubble.textContent = text;
    } else {
      renderRichText(bubble, stripMarkdown(text));
    }
    row.appendChild(bubble);
    container.insertBefore(row, container.lastElementChild);
    container.scrollTop = container.scrollHeight;
  }

  document.addEventListener("DOMContentLoaded", function () {
    const button = document.createElement("button");
    button.id = "chatbot-widget-button";
    button.setAttribute("aria-label", "Chat oeffnen");
    button.innerHTML = CHAT_ICON;
    document.body.appendChild(button);

    const panel = document.createElement("div");
    panel.id = "chatbot-widget-panel";
    panel.innerHTML =
      '<div id="chatbot-widget-header">' +
      "<div>" +
      '<div id="chatbot-widget-header-title">ELBDAMPF Support</div>' +
      '<div id="chatbot-widget-header-sub">Meist innerhalb weniger Sekunden</div>' +
      "</div>" +
      '<button id="chatbot-widget-close" aria-label="Chat schliessen">×</button>' +
      "</div>" +
      '<div id="chatbot-widget-messages">' +
      '<div id="chatbot-widget-typing"><span></span><span></span><span></span></div>' +
      "</div>" +
      '<div id="chatbot-widget-input-row">' +
      '<input id="chatbot-widget-input" type="text" placeholder="Frag uns etwas..." autocomplete="off" />' +
      '<button id="chatbot-widget-send" aria-label="Senden">' +
      SEND_ICON +
      "</button>" +
      "</div>";
    document.body.appendChild(panel);

    const messagesEl = panel.querySelector("#chatbot-widget-messages");
    const typingEl = panel.querySelector("#chatbot-widget-typing");
    const inputEl = panel.querySelector("#chatbot-widget-input");
    const sendEl = panel.querySelector("#chatbot-widget-send");
    const closeEl = panel.querySelector("#chatbot-widget-close");

    let history = loadHistory();
    history.forEach(function (h) {
      renderMessage(messagesEl, h.role, h.content);
    });
    if (history.length === 0) {
      renderMessage(
        messagesEl,
        "assistant",
        "Hallo! Wie kann ich dir bei deiner Bestellung oder unseren Produkten helfen?"
      );
    }

    function openPanel() {
      panel.classList.add("open");
      inputEl.focus();
    }

    function closePanel() {
      panel.classList.remove("open");
    }

    button.addEventListener("click", function () {
      panel.classList.contains("open") ? closePanel() : openPanel();
    });
    closeEl.addEventListener("click", closePanel);

    function sendMessage() {
      const message = inputEl.value.trim();
      if (!message || sendEl.disabled) return;
      inputEl.value = "";
      renderMessage(messagesEl, "user", message);
      history.push({ role: "user", content: message });

      sendEl.disabled = true;
      typingEl.classList.add("visible");
      messagesEl.scrollTop = messagesEl.scrollHeight;

      fetch(CHATBOT_API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: message, history: history, customer_email: getCustomerEmail() }),
      })
        .then(function (res) {
          if (res.status === 429) {
            return { reply: "Bitte kurz warten, bevor du die naechste Nachricht schickst." };
          }
          return res.json();
        })
        .then(function (data) {
          renderMessage(messagesEl, "assistant", data.reply);
          history.push({ role: "assistant", content: data.reply });
          saveHistory(history);
        })
        .catch(function () {
          renderMessage(
            messagesEl,
            "assistant",
            "Entschuldige, gerade klappt das nicht. Bitte nutze das Kontaktformular unter /pages/contact."
          );
        })
        .finally(function () {
          typingEl.classList.remove("visible");
          sendEl.disabled = false;
        });
    }

    inputEl.addEventListener("keydown", function (e) {
      if (e.key === "Enter") sendMessage();
    });
    sendEl.addEventListener("click", sendMessage);
  });
})();
